import React from 'react';
import i18next from 'i18next';
import { IconButton, Icon } from '@material-ui/core';
import { DateFormatter, Rating } from 'components/AppTable/CellsComponents';

const formatTrainingPart = (versionCode, trainingMethod) => {
  if (!versionCode && !trainingMethod) {
    return '—';
  }
  if (!trainingMethod) {
    return versionCode || '—';
  }
  const methodLabel = i18next.t(`trainingModules.tabs.${trainingMethod}`, { defaultValue: trainingMethod });
  return versionCode ? `${versionCode} (${methodLabel})` : `(${methodLabel})`;
};

const formatSessionName = (code, name) => {
  if (!code && !name) {
    return '—';
  }
  if (!code) {
    return name;
  }
  if (!name) {
    return code;
  }
  return `${code}. ${name}`;
};

/** Student result status for the table Status column (not session lifecycle). */
const mapParticipantStatusToResult = participantStatus => {
  if (participantStatus === 'completed') {
    return 'Passed';
  }
  if (participantStatus === 'failed') {
    return 'Failed';
  }
  return 'Pending';
};

const mapParticipantStatusForRating = participantStatus => {
  if (participantStatus === 'completed') {
    return 'Passed';
  }
  if (participantStatus === 'failed') {
    return 'Failed';
  }
  return 'In Progress';
};

const getStudentTableConfig = helpers => [
  {
    title: i18next.t('tablesLabels.id'),
    field: 'id',
    columnWidth: '40px',
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.trainingModule'),
    field: 'trainingModuleCode',
    dependentField: 'trainingModuleName',
    columnWidth: '220px',
    Component: formatSessionName,
  },
  {
    title: i18next.t('trainingSessions.trainingPart'),
    field: 'trainingPartVersionCode',
    dependentField: 'trainingMethod',
    columnWidth: '160px',
    Component: formatTrainingPart,
  },
  {
    title: i18next.t('tablesLabels.status'),
    field: 'resultStatus',
    columnWidth: '100px',
    Component: value => {
      switch (value) {
        case 'Passed':
          return 'Passed';
        case 'Failed':
          return 'Failed';
        case 'Pending':
          return 'Pending';
        default:
          return value || 'Pending';
      }
    },
  },
  {
    title: i18next.t('complianceStatus'),
    field: 'complianceStatus',
    columnWidth: '120px',
    Component: value =>
      value
        ? i18next.t(`compliance.statuses.${value}`, { defaultValue: value })
        : i18next.t('compliance.statuses.incomplete'),
  },
  {
    title: i18next.t('tablesLabels.expiryDate'),
    field: 'expirationDate',
    columnWidth: '120px',
    Component: value =>
      value == null ? i18next.t('trainingSessions.incomplete') : <DateFormatter value={value} />,
  },
  {
    title: i18next.t('tablesLabels.certificate'),
    field: 'certificate',
    dependentField: 'id',
    alignment: 'center',
    columnWidth: '100px',
    Component: (certificate, trainingSessionId) => {
      if (!certificate) {
        return i18next.t('trainingSessions.incomplete');
      }

      return (
        <IconButton
          size="small"
          onClick={() => {
            helpers.handleShowCertificate(trainingSessionId, certificate);
          }}
        >
          <Icon>cloud_download</Icon>
        </IconButton>
      );
    },
  },
  {
    title: i18next.t('formLabels.trainers'),
    field: 'trainerName',
    columnWidth: '160px',
    Component: value => value || '—',
  },
  {
    title: i18next.t('tablesLabels.rating'),
    field: 'feedback',
    dependentField: 'id',
    alignment: 'center',
    Component: (val, trainingSessionId) => (
      <Rating val={val} id={trainingSessionId} onChange={helpers.handleRatingModal} />
    ),
  },
  {
    title: 'ratingHidden',
    field: 'rating',
    isVisible: false,
  },
  {
    title: 'participantStatusHidden',
    field: 'participantStatus',
    isVisible: false,
  },
  {
    title: 'hasMoodleLinkHidden',
    field: 'hasMoodleLink',
    isVisible: false,
  },
  {
    title: 'moodleAccessStateHidden',
    field: 'moodleAccessState',
    isVisible: false,
  },
];

export { mapParticipantStatusForRating, mapParticipantStatusToResult };
export default getStudentTableConfig;
